import React from 'react';
import {
	Create,
	SimpleForm,
	ReferenceInput,
	SelectInput,
	TextInput,
	BooleanInput,
	Toolbar,
	SaveButton
} from 'react-admin';
import { Grid } from '../../components/wrapper';
import { countriesForSelection } from '../../i18n/en.js';

const BusinessContractRouteCreateToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
	</Toolbar>
);

const BusinessContractRouteCreate = props => {
	/**
	 * Redirect back to the business contract instead of the business contract route list.
	 */
	const handleRedirect = (basePath, id, data) => {
		return `/businessContracts/${data.businessContractId}`;
	};

	return (
		<Create {...props}>
			<SimpleForm variant="standard" toolbar={<BusinessContractRouteCreateToolbar />} redirect={handleRedirect}>
				<Grid container spacing={2}>
					<Grid item xs>
						<SelectInput
							source="countryCode"
							choices={countriesForSelection}
							fullWidth
						/>
						<ReferenceInput source="currencyCode" reference="currencies">
							<SelectInput optionText="id" fullWidth />
						</ReferenceInput>
						<TextInput source="mccFrom" fullWidth />
						<TextInput source="mccTo" fullWidth />
					</Grid>
					<Grid item xs>
						<TextInput source="userVerificationLevel" fullWidth />
						<TextInput source="paymentContext" fullWidth />
						<SelectInput
							source="paymentInstrumentStatus"
							choices={[{ id: 'New', name: 'New' }, { id: 'Existing', name: 'Existing' }]}
							resettable
							fullWidth
						/>
						<ReferenceInput source="binGroupId" reference="binGroups">
							<SelectInput optionText="groupName" resettable fullWidth />
						</ReferenceInput>
					</Grid>
				</Grid>
				<TextInput source="comment" fullWidth />
				<BooleanInput source="allowed" fullWidth />
				<BooleanInput source="enabled" fullWidth />
			</SimpleForm>
		</Create>
	);
};

export default BusinessContractRouteCreate;
